module.exports = __webpack_public_path__ + "img/haoojoblogo.7c831f12.svg";